<template>
  <BModal
    :model-value="modal"
    scrollable
    centered
    title="Guest"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">Guest Form</h5>
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>
    <BForm>
      <BRow>
        <BCol md="4">
          <div class="form-group">
            <BFormSelect
              v-model="guestForm.alias"
              :options="titles"
              class="form-select"
              :disabled="isLoading"
            >
              <template #first>
                <BFormSelectOption :value="null" disabled
                  >Select title</BFormSelectOption
                >
              </template>
            </BFormSelect>
          </div>
        </BCol>
        <BCol md="8">
          <div class="form-group">
            <BFormInput
              type="text"
              v-model="guestForm.fullname"
              placeholder="Name"
              :disabled="isLoading"
            >
            </BFormInput>
          </div>
        </BCol>
      </BRow>
      <div class="form-group">
        <BFormInput
          type=""
          v-model="guestForm.identity_number"
          placeholder="ID/Passport (optional)"
          :disabled="isLoading"
        >
        </BFormInput>
      </div>
      <div class="form-group">
        <BFormInput
          type="number"
          v-model="guestForm.phone"
          placeholder="No Contact (optional)"
          :disabled="isLoading"
        >
        </BFormInput>
      </div>
      <BRow>
        <BCol>
          <div class="form-group position-relative">
            <BFormInput
              type="text"
              v-model="searchCountry"
              @focus="isTyped = true"
              @blur="handleBlur"
              placeholder="Nationality"
              :disabled="isLoading"
            >
            </BFormInput>
            <BListGroup
              v-if="
                searchCountry.length > 0 &&
                filteredCountries.length > 0 &&
                isTyped
              "
              class="position-absolute w-100 border rounded-lg"
              style="
                z-index: 10;
                cursor: pointer;
                max-height: 200px;
                overflow-y: scroll;
              "
            >
              <BListGroupItem
                v-for="(nationality, index) in filteredCountries"
                :key="index"
                :value="guestForm.nationality"
                @mousedown.prevent="selectNationality(nationality.country)"
                class="p-2 border-0"
                >{{ nationality.country }}
              </BListGroupItem>
            </BListGroup>
          </div>
        </BCol>
        <BCol>
          <div class="form-group">
            <BFormInput
              type="text"
              v-model="guestForm.city"
              placeholder="City (optional)"
              :disabled="isLoading"
            >
            </BFormInput>
          </div>
        </BCol>
      </BRow>
      <div class="form-group">
        <label for="">Identity Photo (optional)</label>
        <BFormInput
          type="file"
          v-model="guestForm.identity_photo"
          :disabled="isLoading"
        >
        </BFormInput>
        <BFormText id="input-live-help">max.500 KB</BFormText>
      </div>
      <div class="form-group">
        <BFormTextarea
          v-model="guestForm.address"
          placeholder="Address (optional)"
          rows="3"
          :disabled="isLoading"
        />
      </div>
    </BForm>
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton
          variant="primary"
          @click="handleAction"
          class="mr-2"
          :disabled="isLoading"
        >
          {{
            isLoading
              ? "Loading..."
              : guestData && guestData.uuid
              ? "Update"
              : "Save"
          }}
        </BButton>
        <BButton
          variant="danger"
          @click="updateModal(false)"
          :disabled="isLoading"
        >
          Cancel
        </BButton>
      </div>
    </template>
  </BModal>
  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  ></ToastResponse>
</template>

<script>
import {
  BModal,
  BRow,
  BCol,
  BForm,
  BListGroup,
  BListGroupItem,
  BFormSelect,
  BFormSelectOption,
  BButton,
  BFormInput,
  BFormTextarea,
} from "bootstrap-vue-next";

import { ref, inject, watch, onMounted, nextTick } from "vue";
import countryRepository from "@/repositories/countryRepository";
import ToastResponse from "@/components/ToastResponse.vue";

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BForm,
    BListGroup,
    BListGroupItem,
    BFormSelect,
    BFormSelectOption,
    BButton,
    BFormInput,
    BFormTextarea,
    ToastResponse,
  },
  props: {
    modal: Boolean,
    guestData: Object,
  },
  emits: ["update:modal", "addOrUpdate"],

  setup(props, { emit }) {
    const repositories = inject("repositories");
    const guestRepository = repositories ? repositories.guests : null;
    const countries = ref([]);
    const filteredCountries = ref([]);
    const searchCountry = ref("");
    const isTyped = ref(false);
    const isLoading = ref(false);
    const guestForm = ref({
      alias: null,
      fullname: "",
      identity_number: "",
      phone: "",
      nationality: "",
      city: "",
      address: "",
      identity_photo: null,
    });
    const modalResponse = ref({
      toast: false,
      text: "",
      success: false,
    });

    const getListCountry = () => {
      countryRepository
        .getAll()
        .then((res) => {
          countries.value = Object.values(res);
          // console.log(res)
          console.log(countries.value);
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const selectNationality = (country) => {
      searchCountry.value = country;
      guestForm.value.nationality = country;
      nextTick(() => {
        filteredCountries.value = [];
      });
      console.log(event);
    };

    const titles = ref([
      { text: "Mr", value: "mr" },
      { text: "Ms", value: "ms" },
      { text: "Mrs", value: "mrs" },
    ]);
    

    const updateModal = (value) => {
      emit("update:modal", value);
    };
    const handleAction = () => {
      isLoading.value = true;
      props.guestData.uuid ? update() : create();
    };

    const handleBlur = () => {
      setTimeout(() => {
        isTyped.value = false;
      }, 200);
    };
    const create = async () => {
      await guestRepository
        .create(guestForm.value)
        .then((res) => {
          updateModal(false);
          guestForm.value = {};

          if (res.data.success === false) {
            modalResponse.value.success = false;
            modalResponse.value.text = "Failed to create guest";
          } else {
            modalResponse.value.success = true;
            modalResponse.value.text = "Guest created successfully";
          }
          modalResponse.value.toast = true;
          emit("addOrUpdate");
          isLoading.value = false;
        })
        .catch((err) => {
          console.error(err);
          isLoading.value = false;
        });
    };

    const update = async () => {
      await guestRepository
        .update(props.guestData.uuid, guestForm.value)
        .then(() => {
          updateModal(false);
          guestForm.value = {};
          emit("addOrUpdate");
          isLoading.value = false;
        })
        .catch((err) => {
          console.error(err);
          isLoading.value = false;
        });
    };

    onMounted(() => {
      getListCountry();
    });

    watch(searchCountry, (newCountry) => {
      if (!newCountry && isTyped.value) {
        filteredCountries.value = [];
      } else {
        filteredCountries.value = countries.value.filter((country) => {
          return country.country
            .toLowerCase()
            .includes(newCountry.toLowerCase());
        });
      }
    });

    watch(
      () => props.guestData,
      (newData) => {
        if (newData) {
          if (newData.nationality) {
            searchCountry.value = newData.nationality;
          }
          guestForm.value = newData;
        }
      },
      { immediate: true }
    );

    return {
      create,
      update,
      updateModal,
      handleAction,
      handleBlur,
      selectNationality,
      guestForm,
      countries,
      searchCountry,
      isTyped,
      filteredCountries,
      titles,
      isLoading,
      modalResponse,
    };
  },
};
</script>

<style></style>
